import { useAuth } from "@/contexts/AuthContext";
import { PageHeader } from "@/components/Layout";
import BrandingSection from "@/components/settings/BrandingSection";
import EmailDiagnosticsSection from "@/components/settings/EmailDiagnosticsSection";
import WorkingDaysSection from "@/components/settings/WorkingDaysSection";
import PreviewAsSection from "@/components/settings/PreviewAsSection";
import ExternalToolsSection from "@/components/settings/ExternalToolsSection";
import DangerZoneSection from "@/components/settings/DangerZoneSection";

export default function SettingsPage() {
  const { user, settings, refreshSettings } = useAuth();

  if (!user || user.role !== "Admin") {
    return (
      <div className="min-h-screen bg-white">
        <PageHeader title="Settings" subtitle="Admin only" />
        <div className="px-4 sm:px-8 py-6 text-sm text-slate-500">You do not have access to this page.</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="settings-page">
      <PageHeader title="Settings" subtitle="Portal configuration" />
      <div className="px-4 sm:px-8 py-6 space-y-10 max-w-4xl">
        <BrandingSection settings={settings} refresh={refreshSettings} />
        <EmailDiagnosticsSection user={user} />
        <WorkingDaysSection settings={settings} refresh={refreshSettings} />
        <PreviewAsSection />
        <ExternalToolsSection />
        <DangerZoneSection />
      </div>
    </div>
  );
}
